import { useSettingsStore } from "./store";

export const initializeSettingsStore = () => {
  const loadSettings = useSettingsStore.getState().loadSettings;
  loadSettings();
};
